"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Channel = void 0;
var _react = _interopRequireWildcard(require("react"));
var _streamChatReact = require("stream-chat-react");
var _utils = require("../../../utils");
var _EmptyStateIndicator = require("../EmptyStateIndicator");
var _ChatMessageInput = require("../ChatMessageInput");
var _ChatMessageSimple = require("../ChatMessageSimple");
var _CustomAvatar = require("../../GroupChats/components/CustomAvatar");
var _TeamMessageEditForm = _interopRequireDefault(require("../../GroupChats/components/TeamMessageEditForm"));
var _ReconnectModule = require("../ReconnectModule/ReconnectModule");
var _utils2 = require("../../GroupChats/utils");
var _DateSeparator2 = _interopRequireDefault(require("../../GroupChats/components/DateSeparator"));
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var Channel = function Channel(_ref) {
  var owner = _ref.owner,
    previewUserId = _ref.previewUserId,
    previewerCheck = _ref.previewerCheck,
    emptyMessageListText = _ref.emptyMessageListText,
    _ref$messageActions = _ref.messageActions,
    messageActions = _ref$messageActions === void 0 ? _utils.ALLOWED_MESSAGE_ACTIONS.PRIVATE : _ref$messageActions,
    _ref$editMessageInput = _ref.editMessageInputMaxRows,
    editMessageInputMaxRows = _ref$editMessageInput === void 0 ? 1 : _ref$editMessageInput,
    _ref$inputGrow = _ref.inputGrow,
    inputGrow = _ref$inputGrow === void 0 ? true : _ref$inputGrow,
    _ref$inputMaxRows = _ref.inputMaxRows,
    inputMaxRows = _ref$inputMaxRows === void 0 ? 3 : _ref$inputMaxRows,
    handleChannelListOpenChange = _ref.handleChannelListOpenChange,
    ChannelHeader = _ref.ChannelHeader,
    clinicianPatients = _ref.clinicianPatients;
  var _useContext = (0, _react.useContext)(_streamChatReact.ChatContext),
    channel = _useContext.channel;
  if (!channel) {
    return null;
  }
  var members = channel.state.members;
  var member = (0, _utils.getChatMember)({
    members: members,
    owner: owner,
    previewUserId: previewUserId
  });
  var isFrozen = channel.data.frozen;
  var isInChat = (0, _utils.isUserInChat)({
    members: members,
    owner: owner
  });
  var previewer = (0, _utils.getChatPreviewerMember)({
    members: members,
    owner: owner,
    isInChat: isInChat,
    previewerCheck: previewerCheck
  });
  var isReadOnly = isFrozen || !isInChat;
  var previewerId = previewerCheck ? previewer === null || previewer === void 0 ? void 0 : previewer.id : previewUserId;
  if (!isInChat && !isReadOnly) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)({
      'str-chat__wrapper--read-only': isReadOnly
    })
  }, /*#__PURE__*/_react.default.createElement(_streamChatReact.Channel, {
    channel: channel,
    Avatar: _CustomAvatar.CustomAvatar,
    EditMessageInput: _TeamMessageEditForm.default,
    DateSeparator: function DateSeparator(props) {
      return /*#__PURE__*/_react.default.createElement(_DateSeparator2.default, _extends({}, props, {
        formatTitleDate: _utils2.formatChatSeparatorDateTitle
      }));
    }
  }, /*#__PURE__*/_react.default.createElement(_streamChatReact.Window, null, ChannelHeader && /*#__PURE__*/_react.default.createElement(ChannelHeader, {
    member: member,
    onBack: handleChannelListOpenChange,
    clinicianPatients: clinicianPatients
  }), /*#__PURE__*/_react.default.createElement(_streamChatReact.MessageList, {
    EmptyStateIndicator: (0, _EmptyStateIndicator.getEmptyStateIndicator)({
      type: _EmptyStateIndicator.emptyIndicatorTarget.CHAT,
      text: emptyMessageListText,
      role: member === null || member === void 0 ? void 0 : member.applicationRole
    }),
    messageActions: isReadOnly ? false : messageActions,
    Message: function Message(props) {
      return /*#__PURE__*/_react.default.createElement(_ChatMessageSimple.ChatMessageSimple, _extends({}, props, {
        isChatFrozen: isReadOnly,
        previewUserId: previewerId,
        clinicianPatients: clinicianPatients
      }));
    },
    additionalMessageInputProps: {
      maxRows: editMessageInputMaxRows
    }
  }), !isReadOnly && !previewerId && /*#__PURE__*/_react.default.createElement(_ChatMessageInput.ChatMessageInput, {
    grow: inputGrow,
    maxRows: inputMaxRows
  }), isReadOnly && /*#__PURE__*/_react.default.createElement(_ReconnectModule.ReconnectModule, {
    owner: owner,
    members: members
  }))));
};
exports.Channel = Channel;